import GridTile from "../grid/GridTile";
import LayerDescription from "../grid/LayerDescription";
import TileType from "../grid/TileType";
import TerrainLayer from "./TerrainLayer";

export default class SkyTerrainLayer extends TerrainLayer {
    /**
     * @param {TileType} tileType 
     * @param {LayerDescription} layerDescription
     */
    constructor(tileType, layerDescription) {
        super();
        /**
         * @constant
         * @type {TileType}
         */
        this.tileType = tileType;

        /**
         * @constant
         * @type {LayerDescription}
         */
        this.layerDescription = layerDescription;

        // The sky goes up infinitely, so there is no min depth, but we need to extend
        // a little underground in case there is a dip in the surface.

        /**
         * @constant
         * @type {number}
         */
        this.maxSkyTileDepth = 20; // Should this be equal to the tile fudge in BasicTerrainLayer?
    }

    /**
     * @abstract
     * @returns {LayerDescription}
     */
    getLayerDescription() {
        return this.layerDescription;
    }

    /**
     * @override
     * @param {number} minGridTileDepth
     * @param {number} maxGridTileDepth
     * @returns {boolean}
     */
    isLayerForGrid(minGridTileDepth, maxGridTileDepth) {
        return minGridTileDepth < this.maxSkyTileDepth;
    }

    /**
     * @override
     * @param {GridTile} tile The tile
     * @param {number} tileDepth The depth of the tile in tile rows.
     * @returns {boolean}
     */
    isLayerForTile(tile, tileDepth) {
        return tileDepth < this.maxSkyTileDepth;
    }

    /**
     * @override
     * @returns {boolean} True if the terrain layer has lesser tiles
     */
    isOreTileSupported() {
        return false;
    }

    /**
     * @override
     * @returns {boolean} True if the terrain layer has greater tiles
     */
    isGoldTileSupported() {
        return false;
    }

    /**
     * @override
     * @returns {boolean} True if the terrain layer has greater tiles
     */
    isRubyTileSupported() {
        return false;
    }

    /**
     * @override
     * @returns {boolean} True if the terrain layer has rare tiles
     */
    isUpgradeTileSupported() {
        return false;
    }

    /**
     * @override
     * @param {GridTile} tile 
     */
    assignTileToOreType(tile) {
        tile.tileInit(true, this.tileType);
    }
    /**
     * @override
     * @param {GridTile} tile 
     */
    assignTileToGoldType(tile) {
        tile.tileInit(true, this.tileType);
    }
    /**
     * @override
     * @param {GridTile} tile 
     */
    assignTileToUpgradeType(tile) {
        tile.tileInit(true, this.tileType);
    }
    /**
     * @override
     * @param {GridTile} tile 
     */
    assignTileToRubyType(tile) {
        tile.tileInit(true, this.tileType);
    }

    /**
     * @override
     * @param {GridTile} tile 
     * @param {boolean} open
     */
    assignTileTerrain(tile, open) {
        tile.tileInit(true, this.tileType); // <-- sky tiles always open.
    }
}